import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AsyncFormRequest } from 'src/Utils/headerBuilder'

const initialState = () => {
  return {
    sidebarShow: true,
    asideShow: false,
    sidebarUnfoldable: false,
    theme: 'default',
    activeKey: 1,
    Enums: null,
    OdataEnums: null,
    ShowInprogressModal: false,
  }
}

export const GetEnums = createAsyncThunk('GetEnums', async (data) => AsyncFormRequest('/Enum/get'))
export const GetOdataEnums = createAsyncThunk('GetOdataEnums', async (data) =>
  AsyncFormRequest('/Enum/getOdata'),
)

const LayoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    ToggleAside: (state, value) => {
      state.asideShow = !state.asideShow
    },
    Sidebar: (state, val) => {
      state.sidebarShow = val.payload
    },
    SetTheme: (state, value) => {
      state.theme = value.payload
    },
    SetActiveKey: (state, value) => {
      state.activeKey = value.payload
    },
    SetSidebarUnfoldable: (state, value) => {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    InprogressModal: (state, val) => {
      state.ShowInprogressModal = val.payload
    },
  },
  extraReducers: {
    [GetEnums.pending]: (state) => {
      state.isLoading = true
    },
    [GetEnums.fulfilled]: (state, action) => {
      state.Enums = action.payload
    },
    [GetEnums.rejected]: (state, action) => {},
    [GetOdataEnums.pending]: (state) => {
      state.isLoading = true
    },
    [GetOdataEnums.fulfilled]: (state, action) => {
      state.OdataEnums = action.payload
    },
    [GetOdataEnums.rejected]: (state, action) => {},
  },
})

export const {
  ToggleAside,
  SetTheme,
  Sidebar,
  SetActiveKey,
  SetSidebarUnfoldable,
  InprogressModal,
} = LayoutSlice.actions

export default LayoutSlice.reducer
